import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    AppBar, Toolbar
} from '@mui/material';
import {Add} from '@mui/icons-material';
import HeaderAvatar from "../components/HeaderAvatar";
import {
    fetchUserPermissions
} from '../services/api';
import {usePermissions} from "../components/PermissionsContext";

const Statistics: React.FC = () => {
    const { permissions } = usePermissions();
    const [loading, setLoading] = useState(true);


    return (
        <Box>
            <AppBar className={loading ? 'headerBlock preloading' : 'headerBlock'} position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>Статистика <span>0</span></Box>
                    <Button className="addToobarBtn" variant="contained" onClick={() => {}}><Add /></Button>
                    <HeaderAvatar/>
                </Toolbar>
            </AppBar>
        </Box>
    );
};

export default Statistics;